// extracted by mini-css-extract-plugin
export default {"navCard":"NavCard_navCard__qmrZI","withIcon":"NavCard_withIcon__dgyBD","useMedia":"NavCard_useMedia__osUhu"};